import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ProductGetAll } from '../../services';

export const fetchProductGetAll = createAsyncThunk(
    'productGetAll/fetchProductGetAll',
    async () => {
        const response = await ProductGetAll()
        return response.result
    }
);

const productGetAllSlice = createSlice({
    name: 'productGetAll',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductGetAll.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchProductGetAll.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchProductGetAll.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default productGetAllSlice.reducer;
